<template>
    <div>
        <v-expansion-panel expand v-model="expanded">
            <v-expansion-panel-content>
                <template v-slot:header>
                    <h2>Driver Behaviour</h2>
                </template>

                <div class="driver-behaviour">
                    <!--                    <div class="driver-behaviour__left">-->
                    <!--                        <div class="driver-behaviour__box-title">Overspeed</div>-->
                    <!--                        <div class="driver-behaviour__graph">-->
                    <!--                            <GChart type="PieChart" :options="options" :data="data" style="width: 120px; height: 120px;"></GChart>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="driver-behaviour__right">
                        <div class="driver-behaviour__driver">
                            <icon icon="driver" color="#808080"></icon>
                            {{ driver || 'Unknown' }}
                        </div>
                        <div class="driver-behaviour__alerts">
                            <div class="driver-behaviour__adas">
                                <div class="driver-behaviour__box-title">ADAS Alerts</div>
                                <div class="driver-behaviour__box-value">{{ this.adasCounter }}</div>
                            </div>
                            <div class="driver-behaviour__dsm">
                                <div class="driver-behaviour__box-title">DSM Alerts</div>
                                <div class="driver-behaviour__box-value">{{ this.dsmCounter }}</div>
                            </div>
                        </div>
                        <div class="driver-behaviour__speeding">
                            <div class="driver-behaviour__max-speed">
                                <div class="driver-behaviour__box-title">Max speed</div>
                                <div class="driver-behaviour__box-value">{{ speed || 0 }}</div>
                            </div>
                            <div class="driver-behaviour__limit">
                                <div class="driver-behaviour__box-title">Limit</div>
                                <div class="driver-behaviour__box-value">{{ speedLimit || 0 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
import Icon from '@/components/atoms/Icon'
import Telemetry from '@/models/Telemetry'
export default {
    name: 'DriverBehaviour',
    components: { Icon },
    props: {
        events: {
            required: true,
            type: Array
        },
        driver: {
            required: false,
            type: [String, null]
        },
        maxSpeed: {
            required: false,
            type: [Number, null]
        },
        telemetryExtended: {
            required: true,
            type: Telemetry
        }
    },
    data () {
        return {
            speed: 0,
            speedLimit: 0,
            adasCounter: 0,
            dsmCounter: 0,
            options: {
                pieHole: 0.6,
                pieSliceTextStyle: {
                    color: 'black'
                },
                legend: 'none',
                chartArea: {
                    left: '5%',
                    top: '5%',
                    width: '90%',
                    height: '90%'
                }
            },
            data: [
                ['Effort', 'Amount given'],
                ['My all', 80],
                ['My all', 20]
            ],
            expanded: [false]
        }
    },
    mounted () {
        this.events.forEach((event) => {
            if (event.isADAS) {
                this.adasCounter++
            }

            if (event.isDSM) {
                this.dsmCounter++
            }

            if (event.eventTypes.includes(1)) {
                console.debug('DriverBehaviour', event)
            }
        })
        this.resolveMaxSpeeds()
    },
    methods: {
        resolveMaxSpeeds () {
            this.telemetryExtended.journeySpeedPoints.forEach((speedPoint) => {
                if (speedPoint.speed) {
                    this.speed = this.speed > speedPoint.speed ? this.speed : speedPoint.speed
                }
                if (speedPoint.speedLimit) {
                    this.speedLimit = this.speedLimit > speedPoint.speedLimit ? this.speedLimit : speedPoint.speedLimit
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.driver-behaviour {
    display: flex;

    &__left,
    &__right {
        width: 100%;
        display: flex;
        flex-flow: column;
    }

    &__box-title {
        font-size: 12px;
        font-weight: bold;
    }

    &__box-value {
        font-size: 12px;
    }

    &__graph {
        padding: 10px 0;
    }

    &__driver {
        padding: 0 9px;
        font-size: 14px;
        margin-bottom: 15px;
    }

    &__alerts,
    &__speeding {
        display: flex;
        padding: 5px 0;
    }

    &__adas,
    &__dsm,
    &__max-speed,
    &__limit {
        width: 50%;
        display: flex;
        align-items: center;
        flex-flow: column;
    }
}
</style>
